import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { CheckCircleOutlineRounded } from '@mui/icons-material';
import { Box } from '@mui/material';

import { Container } from './styles';

export const SuccessPageToSign = () => {
  const params = useParams();
  const [embedUrl, setEmbedUrl] = useState<string>(
    `https://secure.d4sign.com.br/embed/viewblob/${params.document}?email=${params.email}`,
  );
  const [stepPage, setStepPage] = useState<string>('embed');

  useEffect(() => {
    window.addEventListener(
      'message',
      event => {
        if (event.data === 'signed') {
          setStepPage('success');
        }
        if (event.data === 'wrong-data') {
          toast.error('Erro na assinatura');
        }
      },
      false,
    );
  }, []);

  return (
    <Box width="100vw" height="100vh" padding="20px">
      {stepPage === 'embed' && (
        <Box
          sx={{
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <embed src={embedUrl} style={{ width: '100%', height: '100%' }} />
        </Box>
      )}
      {stepPage === 'success' && (
        <Box
          display="flex"
          alignItems="center"
          flexDirection="column"
          gap="10px"
          height="90%"
          justifyContent="center"
        >
          <CheckCircleOutlineRounded
            color="success"
            sx={{ width: '66px', height: '66px' }}
          />

          <Container display="flex" flexDirection="column">
            <span className="title">Assinatura concluída com sucesso!</span>
          </Container>
          {/* <Text>
            Para visualizar o documento, acesse o Portal de Governança
          </Text> */}

          {/* <ContainerButton>
            <Button
              onClick={() => window.close()}
              variant="outlined"
              sx={{
                display: 'flex',
                height: '42px',
                padding: '6px 22px',
                justifyContent: 'center',
                alignItems: 'center',
                alignSelf: 'stretch',
                borderRadius: '4px',
                border: '1px solid var(--01-primary-main, #160B8C)',
                color: '#160B8C',
              }}
            >
              OK, FECHAR
            </Button>
          </ContainerButton> */}
        </Box>
      )}
    </Box>
  );
};
